import React, { Component } from 'react';
import { connect } from 'react-redux'
import Auth from '../../Auth/Auth';
import { Nav, INavLink } from '@fluentui/react';
import ProfilePicture from "@dsalvagni/react-profile-picture"
import '@dsalvagni/react-profile-picture/dist/ProfilePicture.css';
import Subscriptions from './Subscriptions'
import Invoices from './Invoices'
import { DefaultButton, PrimaryButton, DialogFooter, IconButton, Modal, DayOfWeek,DatePicker, MaskedTextField } from '@fluentui/react';
import { Password } from './Password'
import { Contact } from './Contact'
import { FeatureRequest} from './FeatureRequest'
import { AllNotifications } from './AllNotifications';
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import axios from 'axios';
import { updateUserProfile } from "../../actions"
import ShiftsContext from '../../Context/ShiftsContext'
import { showToast } from '../../actions'
import UpdatePassword from './UpdatePassword';
import PortalComponent from '../../UiKit/SharedComponents/PortalComponent';

function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + (phoneNumberString || '')).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return phoneNumberString || ''
}

const styles = {
    p: {
        fontSize: '14px',
        lineHeight: 1.71,
        color: '#7b8397',
        marginTop: '10px'
    },
    error: {
        color: 'red'
    },
    smallError: {
        color: 'red',
        fontSize: 11,
        marginTop: 4,
        lineHeight: 1.3
    },
    fieldEditBtn: {
        width: 28,
        height: 28
    },
    fieldValue: {
        display: 'inline-flex',
        alignItems: 'center',
        minWidth: 170,
        width: 170
    },
    container: {
        width: 260
    }
};


const DayPickerStrings = {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    goToToday: 'Go to today',
    weekNumberFormatString: 'Week number {0}',
    prevMonthAriaLabel: 'Previous month',
    nextMonthAriaLabel: 'Next month',
    prevYearAriaLabel: 'Previous year',
    nextYearAriaLabel: 'Next year',
    prevYearRangeAriaLabel: 'Previous year range',
    nextYearRangeAriaLabel: 'Next year range',
    closeButtonAriaLabel: 'Close'
};


export class Profile extends React.Component {
    static contextType = ShiftsContext
    constructor(props) {
        super(props);
        this.auth = new Auth();
        
        this.state = {
            open: false,
            accountOpen: false,
            modalStep: this.props.profilePage,
            phoneNumber: this.props.user.phoneNumber ? this.props.user.phoneNumber : "",
            dob: this.props.user.dob ? new Date(this.props.user.dob) : null,
            phoneNumberChanged: false,
            dobChanged:false,
            phoneNumberErrorMsg: '',
            pin: this.props.user.pin ? this.props.user.pin : "",
            pinChanged: false,
            pinErrorMsg: '',
            editingField: null,
            openSnack: false,
            showModal: false,
            navKey: this.props.profilePage
        };
        this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
        this.updatePhoneNumber = this.updatePhoneNumber.bind(this);
        this.profilePictureRef = React.createRef();
    }

    componentDidMount() {

        var links = [
            {
                name: 'Profile',
                key: '1',
                page: '1',
            },
        ]

      

        links.push({
            name: 'Contact Support',
                key: '6',
                page: '6',
            },
            {
                name: 'Feature Request',
                key: '7',
                page: '7',
            });

        this.setState({
            
            links: [
                {
                    links
                }
            ]
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.profilePage != this.props.profilePage) {
            this.setState({ navKey: nextProps.profilePage, modalStep: nextProps.profilePage})
        }
    }

    handleClose = () => {
        this.setState({ accountOpen: false });
    };

    handleClick = (event) => {
        event.preventDefault();
        this.setState({
            open: true,
            anchorEl: event.currentTarget
        });
    };

    handleLogoutClick = () => {
        this.auth.logout();
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
        });
    };

    changeStep = (e, x) => {
        e.preventDefault();
        this.setState({
            modalStep: x,
        });
    };

    handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ openSnack: false });
    };

    startEdit = (field) => {
        // Reset working values from the source of truth and clear any errors.
        this.setState({
            editingField: field,
            phoneNumber: this.props.user.phoneNumber ? this.props.user.phoneNumber : "",
            dob: this.props.user.dob ? new Date(this.props.user.dob) : null,
            pin: this.props.user.pin ? this.props.user.pin : "",
            phoneNumberErrorMsg: '',
            pinErrorMsg: '',
            phoneNumberChanged: false,
            pinChanged: false,
            dobChanged: false
        });
    };

    cancelEdit = () => {
        this.setState({
            editingField: null,
            phoneNumber: this.props.user.phoneNumber ? this.props.user.phoneNumber : "",
            dob: this.props.user.dob ? new Date(this.props.user.dob) : null,
            pin: this.props.user.pin ? this.props.user.pin : "",
            phoneNumberErrorMsg: '',
            pinErrorMsg: '',
            phoneNumberChanged: false,
            pinChanged: false,
            dobChanged: false
        });
    };

    updatePhoneNumber(e) {
        e.preventDefault();
        this.setState({ phoneNumberErrorMsg: '' });

        if (this.telephoneCheck(this.state.phoneNumber.replace(/\D/g, ''))) {
            var model = {
                Value: this.state.phoneNumber.replace(/\D/g, '')
            }
            axios.post(AUTH_CONFIG.API_URL + "/api/Account/UpdatePhoneNumber", model, { suppressGlobalError: true })
                .then((response) => {
                  
                    this.props.user.phoneNumber = this.state.phoneNumber.replace(/\D/g, '');
                    this.props.dispatch(updateUserProfile(this.props.user))
                    this.setState({ phoneNumberErrorMsg: '', phoneNumberChanged: false, editingField: null });
                    this.props.dispatch(showToast({ show: true, message: "Phone number successfully updated." }))
                })
                .catch((error) => {
                    this.setState({ phoneNumberErrorMsg: (error.response && error.response.data) ? error.response.data : 'Unable to update phone number.' })
                });
        } else {
            this.setState({ phoneNumberErrorMsg: 'Invalid phone number' })
        }
    }

    telephoneCheck(str) {
        return /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/.test(str);
    }

    updateDob(e) {
        e.preventDefault();
        var model = {
            Value: this.state.dob
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/Account/UpdateDOB", model)
            .then((response) => {

                this.props.user.dob = this.state.dob;
                this.props.dispatch(updateUserProfile(this.props.user))
                this.setState({ dobChanged: false, editingField: null });
                this.props.dispatch(showToast({ show: true, message: "DOB successfully updated." }))
            });
    }

    handlePhoneNumberChange = (event, value) => {
        this.setState({
            phoneNumber: value,
            phoneNumberChanged: true
        });
    }

    handlePinChange = (event, value) => {
        const digits = (value || '').replace(/\D/g, '').slice(0, 4);
        this.setState({
            pin: digits,
            pinChanged: true,
            pinErrorMsg: ''
        });
    }

    updatePin(e) {
        e.preventDefault();
        this.setState({ pinErrorMsg: '' });

        if (!/^\d{4}$/.test(this.state.pin)) {
            this.setState({ pinErrorMsg: 'PIN must be exactly 4 digits.' });
            return;
        }

        var model = {
            UserId: this.props.user.userId,
            Pin: this.state.pin
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/Account/UpdatePin", model, { suppressGlobalError: true })
            .then((response) => {
                this.props.user.pin = this.state.pin;
                this.props.dispatch(updateUserProfile(this.props.user))
                this.setState({ pinErrorMsg: '', pinChanged: false, editingField: null });
                this.props.dispatch(showToast({ show: true, message: "Login PIN successfully updated." }))
            })
            .catch((error) => {
                this.setState({ pinErrorMsg: (error.response && error.response.data) ? error.response.data : 'Unable to update PIN.' })
            });
    }
    onOpenModal = (event) => {
        event.preventDefault();

        const { toggleProfilePic } = this.context
        toggleProfilePic()


        //this.setState({
        //    showModal: true
        //});
    };


    _renderMenuList = (menuListProps, defaultRender) => {
        return (
            <div>

                {defaultRender(menuListProps)}
            </div>
        );
    };


    _onLinkClick = (e, item) => {
        this.setState({
            modalStep: item.page,
            navKey:item.page
        })
    }

    _onSelectDate = (date) => {
        this.setState({
            dob: date,
            dobChanged: true
        })
    }

    render() {
        return (
            <div className="displayflex flex1 height100" style={{overflow:'hidden'}}>
                <div className="displayflex flexcolumn profile-nav" style={{ overflowY: 'auto' }}>
                    
                    <div className="profile-header-block p20">
                        <h2 className="page-header">Profile Settings</h2>
                    </div>
                    <Nav
                        selectedKey={this.state.navKey}
                        onLinkClick={this._onLinkClick}
                        styles={{
                            root: {
                                width: 230,
                            }
                        }}
                        ariaLabel="Nav basic example"
                        groups={this.state.links}
                    />
                </div>
                <div className="displayflex flex1 height100" style={{  overflowY:'auto' }}>
                    <IconButton iconProps={{ iconName: 'Cancel' }} title="Close" className="profile-close" onClick={() => this.props.closePanel()} />
                    {this.state.modalStep == '1' &&
                        <div class="content-section width100">
                         <div className="profile-header-block">
                            <h2 className="page-header">User Profile</h2>
                        </div>
                        <div class="py20">
                           
                                <div class="profile-overview">
                                    <div class="form-row" style={{ 'overflow': 'hidden', flexDirection:'row' }}>
                                        <div class="icon-object">
                                            {!this.props.user.userImg &&
                                             <i class="ms-Icon ms-Icon--Contact"></i>
                                            }
                                            {this.props.user.userImg &&
                                                <img className="profile-img" src={process.env.REACT_APP_CDN_URL + this.props.user.userImg} />
                                            }
                                    </div>
                                    <div id="angularupload2" className="profile-pic-upload">
                                        <a onClick={(e)=>this.onOpenModal(e)}>Update</a>
                                    </div>
                                    </div>
                                    <div class="form-row">
                                    <label for="blockName" class="small-label mb5">Name</label>
                                    <span class="value ng-binding">{this.props.user.firstName} {this.props.user.lastName}</span>
                                    </div>
                                    <div class="form-row">
                                    <label for="blockName" class="small-label mb5">User name</label>
                                    <span class="value ng-binding">{this.props.user.email}</span>
                                    </div>
                                    <div class="form-row">
                                        <label for="blockName" class="small-label mb5">Phone number</label>
                                        {this.state.editingField !== 'phone' &&
                                            <div className="displayflex aligncenter">
                                                <span class="value ng-binding" style={styles.fieldValue}>{formatPhoneNumber(this.props.user.phoneNumber) || '—'}</span>
                                                <IconButton iconProps={{ iconName: 'Edit' }} title="Edit phone number" style={styles.fieldEditBtn} onClick={() => this.startEdit('phone')} />
                                            </div>
                                        }
                                        {this.state.editingField === 'phone' &&
                                            <div>
                                                <div className="displayflex aligncenter">
                                                    <div style={styles.fieldValue}>
                                                        <MaskedTextField onChange={this.handlePhoneNumberChange} styles={{ root: { width: 150 }, fieldGroup: { width: 150 } }} value={this.state.phoneNumber} mask="(999) 999-9999" />
                                                    </div>
                                                    <IconButton iconProps={{ iconName: 'CheckMark' }} title="Save" style={styles.fieldEditBtn} onClick={(e) => this.updatePhoneNumber(e)} />
                                                    <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancel" style={styles.fieldEditBtn} onClick={() => this.cancelEdit()} />
                                                </div>
                                                {this.state.phoneNumberErrorMsg && <div style={styles.smallError}>{this.state.phoneNumberErrorMsg}</div>}
                                            </div>
                                        }
                                    </div>
                                    <div class="form-row">
                                        <label for="blockName" class="small-label mb5">DOB</label>
                                        {this.state.editingField !== 'dob' &&
                                            <div className="displayflex aligncenter">
                                                <span class="value ng-binding" style={styles.fieldValue}>{this.props.user.dob ? new Date(this.props.user.dob).toDateString() : '—'}</span>
                                                <IconButton iconProps={{ iconName: 'Edit' }} title="Edit date of birth" style={styles.fieldEditBtn} onClick={() => this.startEdit('dob')} />
                                            </div>
                                        }
                                        {this.state.editingField === 'dob' &&
                                            <div className="displayflex aligncenter">
                                                <div style={styles.fieldValue}>
                                                    <DatePicker
                                                        onSelectDate={this._onSelectDate}
                                                        value={this.state.dob}
                                                        firstDayOfWeek={DayOfWeek.Sunday}
                                                        strings={DayPickerStrings}
                                                        placeholder="Select a date..."
                                                        className="short-datepicker"
                                                        styles={{ root: { width: 150, height: '38px' }, textField: { height: '38px', lineHeight: '38px' } }}
                                                    />
                                                </div>
                                                <IconButton iconProps={{ iconName: 'CheckMark' }} title="Save" style={styles.fieldEditBtn} onClick={(e) => this.updateDob(e)} />
                                                <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancel" style={styles.fieldEditBtn} onClick={() => this.cancelEdit()} />
                                            </div>
                                        }
                                    </div>
                                    <div class="form-row">
                                        <label for="blockName" class="small-label mb5">Login PIN</label>
                                        {this.state.editingField !== 'pin' &&
                                            <div className="displayflex aligncenter">
                                                <span class="value ng-binding" style={styles.fieldValue}>{this.props.user.pin || '—'}</span>
                                                <IconButton iconProps={{ iconName: 'Edit' }} title="Edit login PIN" style={styles.fieldEditBtn} onClick={() => this.startEdit('pin')} />
                                            </div>
                                        }
                                        {this.state.editingField === 'pin' &&
                                            <div>
                                                <div className="displayflex aligncenter">
                                                    <div style={styles.fieldValue}>
                                                        <MaskedTextField onChange={this.handlePinChange} styles={{ root: { width: 150 }, fieldGroup: { width: 150 } }} value={this.state.pin} mask="9999" />
                                                    </div>
                                                    <IconButton iconProps={{ iconName: 'CheckMark' }} title="Save" style={styles.fieldEditBtn} onClick={(e) => this.updatePin(e)} />
                                                    <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancel" style={styles.fieldEditBtn} onClick={() => this.cancelEdit()} />
                                                </div>
                                                {this.state.pinErrorMsg && <div style={styles.smallError}>{this.state.pinErrorMsg}</div>}
                                            </div>
                                        }
                                    </div>
                                    <div class="form-row change-link" style={{ marginTop: '15px' }}>
                                        <a href="" onClick={(e) => this.changeStep(e, 2)}>Change your password</a>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    }
                    {this.state.modalStep == '2' &&
                        <div class="content-section  width100">
                            <div className="profile-header-block">
                                <h2 className="page-header">Update Password</h2>
                            </div>
                            <div class="py20">
                             <UpdatePassword />
                                <div className="m-t-30">
                                    <a href="" onClick={(e) => this.changeStep(e, 1)}>Cancel</a>
                                </div>
                            </div>
                        </div>
                }
                    {this.state.modalStep == '3' &&
                        <div class="content-section width100">
                            <div className="profile-header-block">
                            <h2 className="page-header">Notifications</h2>
                            </div>
                        <div class="notification-container list py20">
                            <AllNotifications />
                        </div>
                    </div>
                    }
                    {this.state.modalStep == '4' &&
                        <div class="content-section  width100">
                            <div className="profile-header-block">
                            <h2 className="page-header">Subscriptions</h2>
                            </div>
                            <div class="py20 ">
                            <Subscriptions />
                        </div>
                    </div>
                    }
                    {this.state.modalStep == '5' &&
                        <div class="content-section width100">
                            <div className="profile-header-block">
                            <h2 className="page-header">Invoices</h2>
                            </div>
                            <div class="py20">
                            <div class="profile-overview">
                                <Invoices />
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.modalStep == '6' &&
                        <div class="content-section width100">
                        <div className="profile-header-block">
                            <h2 className="page-header">Contact Support</h2>
                            </div>
                            <div class="py20">
                            <div class="">
                                <Contact type="support" />
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.modalStep == '7' &&
                        <div class="content-section width100">
                        <div className="profile-header-block">
                            <h2 className="page-header">Suggest a feature</h2>
                            </div>
                            <div class="py20">
                            <p className="mb20">Do you have an idea for a new feature or something that will make your job easier? <br />Please let us know and we will make it happen!</p>
                            <div class="">
                                <FeatureRequest />
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.modalStep == '8' &&
                        <div class="content-section width100">
                            <div className="profile-header-block">
                                <h2 className="page-header">Facilities</h2>
                            </div>
                            <div class="py20">
                                <div class="">
                                </div>
                            </div>
                        </div>
                    }
                </div>
              
            </div>
        );
    }
}

const mapStateToProps = state => ({
    profilePage: state.rootReducer.profilePage,
    user: state.userProfile
});

export default connect(mapStateToProps)(Profile);



